





















import * as Fuse from 'fuse.js';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class Autocomplete extends Vue {
  @Prop() public items!: string[];
  @Prop() public hint!: string;
  @Prop() public label?: string;
  @Prop() public icon?: string;
  @Prop() public inputClass?: string;
  @Prop() public iconClass?: string;
  @Prop() public dropdownClass?: string;
  @Prop() public showItems?: number;

  public isOpen = false;
  public results: string[] = [];
  public search = '';
  public arrowCounter = 0;
  public maxItems = this.showItems || 10;

  public onChange() {
    this.$emit('input', this.search);
    this.filterResults();
    this.isOpen = true;
  }

  public filterResults() {
    const fuse = new Fuse(this.items.map(name => ({ name })), {
      caseSensitive: true,
      shouldSort: true,
      minMatchCharLength: 1,
      keys: ['name'],
      id: 'name',
    });
    this.results = fuse.search(this.search);
  }

  public setResult(result: string) {
    this.search = result;
    this.isOpen = false;

    this.$emit('input', result);
  }

  public onArrowDown() {
    if (this.arrowCounter < this.results.length) {
      this.arrowCounter++;
    }
  }

  public onArrowUp() {
    if (this.arrowCounter > 0) {
      this.arrowCounter--;
    }
  }

  public onEnter() {
    this.setResult(this.results[this.arrowCounter]);
    this.arrowCounter = -1;
  }

  public onClickOutside(evt: any) {
    if (!this.$el.contains(evt.target)) {
      this.isOpen = false;
      this.arrowCounter = -1;
    }
  }

  @Watch('items')
  public onItemsChanged(val: string[], oldVal: string[]) {
    if (val.length !== oldVal.length) {
      this.results = val;
    }
  }

  public mounted() {
    document.addEventListener('click', this.onClickOutside);
  }

  public destroyed() {
    document.removeEventListener('click', this.onClickOutside);
  }
}
